export const CURRENT_CART_UPLOAD_BASE_EVENT = `cart:current:upload`;

export enum CartCurrentUploadEvent {
	INIT = `${CURRENT_CART_UPLOAD_BASE_EVENT}:init`,
	INITIALIZED = `${CURRENT_CART_UPLOAD_BASE_EVENT}:initialized`,
	EXTEND = `${CURRENT_CART_UPLOAD_BASE_EVENT}:extend`,

	UPLOAD = `${CURRENT_CART_UPLOAD_BASE_EVENT}:execute`,
}
